import React, {useState, useEffect, useContext} from "react";
import { useSelector } from 'react-redux';
import LazyLoad from 'react-lazyload';
import Button from "react-bootstrap/Button";
import {
  ProductCardWrapper,
  ProductImageWrapper,
  ProductInfo,
  DiscountPercent,
  ProductPriceWrapper,
  ProductPrice,
  PromoPrice,
  BrandLogoWrapper,
  SalePrice,
  ProductButtons,
  FavoriteContainer
} from "./ProductCard.style";
import {useCart} from "../../contexts/cart/use-cart";
import { useFavorites } from "../../contexts/favorites/use-favorites";
import { AuthContext } from "../../contexts/auth/auth.context";
import { QuantityModifier } from "../QuantityModifier/QuantityModifier";
import { cartAnimation } from "../../helper/cart-animation";
import Loader from "../Loader/Loader";
import { compDate } from "../../constants/Constant";
import moment from 'moment';
import itemToCartService from '../../services/itemToCartService';
import SimpleMessageDialog from "../SimpleMessageDialog/SimpleMessageDialog";
import Spinner from 'react-bootstrap/Spinner';
import expressService from "../../services/expressService";
import delishopExpressIcon from '../../assets/icons/delixpress_logo2.svg';
import delishopIcon from '../../assets/icons/delishop_logo2.svg';
import t from '../../i18n/translate';
import { Minus, CartBuy} from "../AllSvgIcon";
import ExpressContext from "../../contexts/expressContext";
import FlagIconFactory from 'react-flag-icon-css';
import { Favorite, FavoriteBorder } from "@material-ui/icons";
import ProductIcon from '../../assets/images/delishop-favicons.png'
import {
	logAddToCart,
	logAddToWishlist,
	logClearCart,
	logRemoveFromCart,
	logRemoveFromWishlist
} from "../../services/googleAnalytics";


const FlagIcon = FlagIconFactory(React, { useCssModules: false });

const outOfStockGray = {
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  backgroundColor: 'rgb(247 247 247 / 60%)',
  zIndex: 1,
};

const ProductCard = ({
  title,
  image,
  weight,
  outOfStock,
  price,
  salePrice,
  discountInPercent,
  cartProducts,
  addToCart,
  updateCart,
  value,
  currency,
  onChange,
  increment,
  decrement,
  data,
  deviceType,
  onClick,
  onCartClick,
  isSameDay,
  promo,
  promoPrice,
  promoStartDate,
  promoEndDate,
  brandId,
  brands,
  loading,
  page,
  promoProduct = false,
  variant = '',
  productCode,
  ...props
}) => {
  const {
    getItem,
    isInCart,
    resetCart,
    fetchOrderItems,
	  items
  } = useCart();
  const {
    addItemToFavorites,
    removeItemFromFavorites,
    isInFavorites,
    favAddLoading,
    favRemoveLoading,
  } = useFavorites();
    const {
    authState: { isAuthenticated },
  } = React.useContext(AuthContext);
  const [loaded, setLoaded] = useState(false);
  const dayNumber = moment().isoWeekday();
  const cartType = useSelector(state => state.cartReducer.cartType);
  const extraBrands = useSelector(state => state.expressReducer.extraBrands);

  // Simple Message Dialog
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showHeaderDialog, setShowHeaderDialog] = useState(false);
  const [isConfirmButton, setIsConfirmButton] = useState(false);
  const [confirmLabel, setConfirmLabel] = useState('OK');
  const [dialogLoading, setDialogLoading] = useState(false);
  const [closeLabel, setCloseLabel] = useState('CLOSE');
  const [dialogHeaderLabel, setDialogHeaderLabel] = useState('Error');
  const [errorLog, setErrorLog] = useState(null);
  const [simpleDialogBackdrop, setSimpleDialogBackdrop] = useState(true);
  let brandName = localStorage.getItem("mode");
  // Update quantity
  const [isLoading, setIsLoading] = useState(false);

  
  useEffect(()=>{
    setLoaded(false);
  },[window.location.pathname]);

  const handleAddClick = async (e) => {
    e.stopPropagation();

    setSimpleDialogBackdrop(true);

    if (!localStorage.getItem("user") || !localStorage.getItem("token")) {
	    if (onCartClick) {
		    onCartClick();
	    } else {
		    const joinBtn = document.getElementById("joinBTn");
		    if (joinBtn) joinBtn.click();
	    }
	    window.trigger = "add to cart";
    } else {
      let itemQuantity = 1;
      setIsLoading(true);
      // If user click on button [Add to cart]
      if (!isInCart(data.item_id)) {
        cartAnimation(e);
      }
      // if user click on button increase item quantity
      else {
        itemQuantity = getItem(data.item_id).quantity + 1;
      }

      const itemResp = await itemToCartService.addItem(data.item_id, cartType, itemQuantity);
      if(itemResp.success) {
        logAddToCart(itemResp.data)
        fetchOrderItems(cartType);
      }
      else {
        if(typeof itemResp.error === 'string' && itemResp.error === "multiSupplier") {
          setIsConfirmButton(true);
          setConfirmLabel( t('shop_add_item_to_cart_different_shop_error_remove') );
          setCloseLabel( t('shop_add_item_to_cart_different_shop_error_cancel') );
          setDialogHeaderLabel( t('shop_add_item_to_cart_different_shop_error_title') )
          setShowHeaderDialog(true);
          setErrorLog({
            error: true,
            error_type: 'multiSupplier'
          });
        }
        else if(itemResp.error && itemResp.data.type === "paymentInProgress") {
          setIsConfirmButton(true);
          setConfirmLabel( t('shop_popup_continue_payment_button') );
          setCloseLabel( t('shop_popup_cancel_payment_button') );
          setDialogHeaderLabel( t('shop_popup_payment_locked_label') )
          setShowHeaderDialog(true);
          setErrorLog({error: true, error_type: 'paymentInProgress'});
          setSimpleDialogBackdrop('static')
        }
        else {
          setErrorLog({error: false});
        }
        setErrorMessage(itemResp.message);
        setShowError(true);
      }
      setIsLoading(false);
    }
  };

  // Simple Dialog
  const closeSimpleDialog = async () => {
    if(errorLog.error && errorLog.error_type === 'paymentInProgress') {
      setDialogLoading(true);
      const orderLockResp = await expressService.orderLocked(cartType);
      if(orderLockResp.status === 200) {
        setTimeout(async () => {
          const itemResp = await itemToCartService.addItem(data.item_id, cartType);

          if(itemResp.success) {
            await fetchOrderItems(cartType);
          }
          else {
            setErrorMessage(itemResp.message);
          }

          setShowError(false);
          setDialogLoading(false);
        }, 250);
      }
      else {
        alert( t('shop_item_update_error') );
        setShowError(false);
        setDialogLoading(false);
      }
    }
    else {
      setShowError(false);
    }
  }
  const onConfirm = () => {
    if(errorLog.error && errorLog.error_type === 'multiSupplier') {
      handleOverWriteCart();
    }
    else if(errorLog.error && errorLog.error_type === 'paymentInProgress') {
      window.location.href = '/checkout'
    }
  }
  const handleOverWriteCart = async () => {
    setDialogLoading(true);

    await resetCart();

    setTimeout(async () => {
      const itemResp = await itemToCartService.addItem(data.item_id, cartType);

      if(itemResp.success) {
        await fetchOrderItems(cartType);
      }
      else {
        setErrorMessage(itemResp.message);
      }

      setShowError(false);
      setDialogLoading(false);
    }, 250);
  };

  const handleRemoveClick = async (e) => {
    e.stopPropagation();
    let itemResp = null;
    if (!localStorage.getItem("user")) {
	    if (onCartClick) {
		    onCartClick();
	    } else {
		    const joinBtn = document.getElementById("joinBTn");
		    if (joinBtn) joinBtn.click();
	    }
	    window.trigger = "add to cart";
    } else if (items.length === 1 && getItem(data.item_id).quantity === 1) {
	    setIsLoading(true);
	    let response = window.confirm(t('home_basket_alert_delete_cart', false));
	    if (response === true) {
		    resetCart();
		    logClearCart()
	    }
	    setIsLoading(false);
    }
    else{
      setIsLoading(true);
      // Remove item from cart When user click on button decrease item quantity <= 1
	    if (items.length > 1 && getItem(data.item_id).quantity === 1) {
        itemResp = await itemToCartService.removeItemFromCart(getItem(data.item_id), cartType);
        logRemoveFromCart(data,1)
      }
      // When user click on button decrease item quantity
      else {
        itemResp = await itemToCartService.addItem(data.item_id, cartType, getItem(data.item_id).quantity - 1);
        logRemoveFromCart(itemResp.data,0)
      }
	    if (!itemResp || itemResp?.success) {
        fetchOrderItems(cartType);
      }
      else {
        setShowError(true);
        setErrorMessage(itemResp.message);
      }
      setIsLoading(false);
    }
  };

  const handleInputUpdateQuantity = async (data, quantity) => {
    if(parseInt(quantity) >= 1) {
      setIsLoading(true);
      const itemResp = await itemToCartService.addItem(data.item_id, cartType, parseInt(quantity));
      if(itemResp.success) {
        fetchOrderItems(cartType);
      }
      else {
        if(typeof itemResp.error === 'string' && itemResp.error === "multiSupplier") {
          setIsConfirmButton(true);
          setConfirmLabel( t('shop_add_item_to_cart_different_shop_error_remove') );
          setCloseLabel( t('shop_add_item_to_cart_different_shop_error_cancel') );
          setDialogHeaderLabel( t('shop_add_item_to_cart_different_shop_error_title') )
          setShowHeaderDialog(true);
        }
        setErrorMessage(itemResp.message);
        setShowError(true);
      }
      setIsLoading(false);
    }
  }

  // const getbrandlogo = (id) => {
  //   var b = brands.filter(elem => {
  //     return elem.brand_id === id   
  //   });
  //   return b.length !== 0 ? b[0].logo : null;
  // };

  // const getBrand = (id) => {
  //   var b = brands.filter(elem => {
  //     return elem.brand_id === id   
  //   });
  //   return b.length !== 0 ? b[0] : null;
  // };
  
  const getBrand = (id) => {
    if (!brands || !Array.isArray(brands)) return null;
    const b = brands.filter(elem => elem.brand_id === id);
    return b.length !== 0 ? b[0] : null;
  };

  const getbrandlogo = (id) => {
    if (!brands || !Array.isArray(brands)) return null;
    const b = brands.filter(elem => elem.brand_id === id);
    return b.length !== 0 ? b[0].logo : null;
  };

  let brandOfItem = getBrand(brandId);

  const addDefaultSrc = (e) => e.target.src = cartType === 'express' ? delishopExpressIcon : delishopIcon;

  function extraBrandImage(brandID) {

    if(extraBrands.length) {
      const findBrand = extraBrands.find(item => item.brand_id === brandID);
      if(typeof findBrand !== "undefined") {
        return <BrandLogoWrapper>
	        <LazyLoad height={140} offset={100}>
            <img
              src={findBrand.logo}
              className="brand-image"
              alt={`${findBrand.name || 'Brand'} logo`}
              title={findBrand.name || 'Brand'}
              loading="lazy"
              decoding="async"
              width="50"
              height="50"
              onError={(e)=>{
                e.target.onerror = null;
                e.target.src = require('../../assets/icons/delishop_logo2.svg');
              }}
            />
          </LazyLoad>
        </BrandLogoWrapper>
      }
      else {
        return null;
      }
    }
  }

  const handleAddRemoveFavorite = (e, target) => {
    e.stopPropagation();
    if (!localStorage.getItem("user") || !localStorage.getItem("token")) {
	    if (onCartClick) {
		    onCartClick();
	    } else {
		    const joinBtn = document.getElementById("joinBTn");
		    if (joinBtn) joinBtn.click();
	    }
      window.trigger = "add to favorites"
    } else {
      let query = { type: cartType === "express" ? 1 : 0, item_id: data.item_id };
      if (target === "remove") {
        if (favRemoveLoading[data.item_id]) return;
        removeItemFromFavorites(query);
        logRemoveFromWishlist(data)
        
      } else {
        if (favAddLoading[data.item_id]) return;
          addItemToFavorites(query);
          logAddToWishlist(data)
      }      
    }

  };


  return (
    <>
      <ProductCardWrapper itemScope itemType="http://schema.org/Product" onClick={onClick} className="product-card">
        <ProductImageWrapper className={cartType}>
          { getbrandlogo(brandId) !== null && getbrandlogo(brandId) !== "" && (!loading || page !== 1)
            ? brandName && brandName ==="brand" ? null :
             <BrandLogoWrapper>
	             <LazyLoad height={140} offset={100}>
                <img
                  src={getbrandlogo(brandId)}
                  className={promoProduct ? "brand-promo" : "brand-image"}
                  alt={`${brandOfItem?.name || 'Brand'} logo`}
                  title={brandOfItem?.name || 'Brand'}
                  loading="lazy"
                  decoding="async"
                  width="50"
                  height="50"
                  onError={(e)=>{
                    e.target.onerror = null;
                    e.target.src = require('../../assets/icons/delishop_logo2.svg');
                  }}
                />
              </LazyLoad>
            </BrandLogoWrapper>
            : extraBrandImage(brandId)
          }
          <div className="ribbon">
            {loaded ? null : <Loader className="loaderStyle" color={cartType === 'express' ? "#f01266" : "#9cc54b"} />}
            <div className="product-image-wrapper">
              {!props.isCloseSEO && (
                <>
                  <meta itemProp="image" content={image ? image : ProductIcon} />
                  <meta itemProp="description" content={props.description ? props.description : ''} />
                </>
              )}
	            <LazyLoad height={140} offset={100}>
              {image
                ? <img
                  src={loading && page === 1 ? require('../../image/white.png') : image}
                  className={promoProduct ? "promo-image product-image" : "product-image"}
                  alt={`${title}${brandOfItem ? ' - ' + brandOfItem.name : ''}`}
                  title={title}
                  loading="lazy"
                  decoding="async"
                  width="200"
                  height="200"
                  onError={addDefaultSrc}
                  onLoad={() => setLoaded(true)}
                />
                : <img
                  src={ProductIcon}
                  className={promoProduct ? "promo-image product-image" : "product-image"}
                  alt={`${title}${brandOfItem ? ' - ' + brandOfItem.name : ''}`}
                  title={title}
                  loading="lazy"
                  decoding="async"
                  width="200"
                  height="200"
                  onError={addDefaultSrc}
                  onLoad={() => setLoaded(true)}
                />
              }
              </LazyLoad>
            </div>
            
            {cartType !== 'express'
	            ? isSameDay && data.is_shop_normal_open
                ? !outOfStock
                  ? <span className="ribbon3">{ t('shop_item_get_same_day') }</span>
                  : null
                : !outOfStock
                  ? data.available_tommorrow && <span className="ribbon3 full-width">
                    { t('shop_item_get_tomorrow') }
                  </span>
                  : null
	            : isSameDay && data.is_shop_open
                ? !outOfStock
                  ? <span className="ribbon3">{ t('shop_item_get_same_day') }</span>
                  : null
                : null
            }
            {promo === 1 && !outOfStock && promoStartDate !== null && promoEndDate !== null && compDate(promoStartDate, promoEndDate) && !loading &&
	            <span className="ribbon4">{t('shop_item_promo_label')}</span>
            }
          </div>
          {discountInPercent && !outOfStock ? (
            <>
              <DiscountPercent>{discountInPercent}%</DiscountPercent>
            </>
          ) : (
            ""
          )}
        </ProductImageWrapper>
        {loading && page === 1  ? <div style={{textAlign: "center", margin: "0 auto", paddingBottom: "20px"}}>{ t('toast_downloading') }</div> : <ProductInfo>
          {outOfStock ? <div style={outOfStockGray}></div> : null}
          {/* Product Name */}
          <div className="d-flex justify-content-between" style={{width: '100%'}}>
            <h3 itemProp={"name"}
              className={promoProduct ? "promo-title product-title" : "product-title"}
              style={{paddingTop: '3px'}}
            >{title} {
              brandOfItem && (
              <><span style={{
                  padding: "0px 4px 0px 0px",
                }}>
                  -
                </span> 
                <span itemProp={"brand"} >
                  {brandOfItem.name} 
                </span>
              </>
            )}</h3>
              
              <FavoriteContainer className={`${cartType}`}>
                {isInFavorites(data.item_id) ? (
                  <Button
                    variant="light"
                    size="sm"
                    className={`btn-favorite ${cartType}`}
                    onClick={(e) => handleAddRemoveFavorite(e, "remove")}
                  >
                    {favRemoveLoading[data.item_id] ? (
                      <Spinner
                        animation="border"
                        size="sm"
                        className="favorites-spinner"
                      />
                    ) : (
                      <Favorite className="favorite-icon" fontSize="small" /> 
                    )}
                  </Button>
                  ) : (
                    <Button
                      variant="light"
                      size="sm"
                      className={`btn-favorite ${cartType}`}
                      onClick={(e) => handleAddRemoveFavorite(e, "add")}
                    >
                      {favAddLoading[data.item_id] ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          className="favorites-spinner"
                        />
                      ) : (
                        <FavoriteBorder className="favorite-icon" fontSize="small" />
                      )}
                    </Button>
                  )}
              </FavoriteContainer>
          </div>
          
          <div className={`product-meta ${cartType}`}>
            <meta itemProp="url" content={"https://delishop.asia"+window.location.pathname} />
            <meta itemProp="sku" content={productCode} />
            <div className="product-body" style={{width: "100%", display: "flex", justifyContent: "space-between", alignItems: "flex-end"}}>
              <div className="product-country-and-weight">
                <div className="product-country">
                  {cartType === "express" ? (
											data.country ? (
												<span>
													<FlagIcon code={data.country.code.toLowerCase()} size="lg" />
												</span>
											) : null
										) : data.countries[0] ? (
											<span>
												<FlagIcon code={data.countries[0].code.toLowerCase()} size="lg" />
											</span>
										) : null}
                </div>
                <div className="product-weight">
                  {/* todo */}
                  { weight ? <p itemProp={"weight"} className={promoProduct ? "promo-weight product-weight" : "product-weight"} style={{fontSize: "1rem"}}>{weight}</p>
                    : null
                  }
                </div>
              </div>
            </div>
            <div className="product-footer" style={{ width: "100%" }}>
              {/* <div className="product-offer"> */}
                <ProductPriceWrapper itemProp={"offers"} itemScope itemType={"https://schema.org/Offer"} className={promoProduct && "promo-price"}>
                  <meta itemProp="availability" content={
                    props.isAvailable == true 
                      ? outOfStock === false ? "https://schema.org/InStock" : "https://schema.org/BackOrder" 
                      : "https://schema.org/Discontinued"} />
                  {salePrice && (
                    <ProductPrice className={promo === 1 && promoStartDate !== null && promoEndDate !== null && compDate(promoStartDate, promoEndDate) ? `strike-through ${cartType}` : ""}>
                      <meta itemProp={"oldPriceCurrency"} content={"USD"} />
                      <span itemProp={"oldPrice"}
                            content={parseFloat(salePrice).toFixed(2)}
                            className={`${cartType} ${promoProduct ? "promo-price" : ""}`}
                      >{currency}{parseFloat(salePrice).toFixed(2)}</span>
                    </ProductPrice>
                  )}
                  { promo === 1 && promoStartDate !== null && promoEndDate !== null && compDate(promoStartDate, promoEndDate) && (
                    <PromoPrice className={promoProduct ? "promo-price" : ""} itemscope itemtype="https://schema.org/PriceSpecification">
                      <meta itemProp={"@type"} content={"UnitPriceSpecification"} />
                      <meta itemProp={"priceType"} content={"https://schema.org/ListPrice"} />
                      <meta itemProp={"priceCurrency"} content={"USD"} />
                      <span itemProp={"price"}
                            content={parseFloat(promoPrice).toFixed(2)}
                            className={`${cartType} ${compDate(promoStartDate, promoEndDate) ? "promo-price" : ""}`}
                      >{currency}{parseFloat(promoPrice).toFixed(2)}</span>
                      <meta itemProp="priceValidUntil" content={promoEndDate} />
                    </PromoPrice>
                  )
                  }
                </ProductPriceWrapper>
              {/* </div> */}
              {cartType !== "express"
                ? outOfStock
                  ? <div className={promoProduct ? "promo-price" : ""} style={{ width: '100%', color: "red",  textAlign: 'end' }}>{ t('shop_item_out_of_stock') }</div>
                    : <ProductButtons>
                      
                  {!isInCart(data.item_id)
                    ? <Button
                        className="btn btn-outline-success"
                        onClick={!isLoading && handleAddClick}
                      >
                        {isLoading
                          ? <Spinner animation="border" role="status" size="sm" style={{color: "#9cc54b"}} />
                          :<span className="cart-icon"><CartBuy/></span>
                        }
                        <span className="cart-buy">Buy</span>
                      </Button>
                    : 
                    <div onClick={(e)=>e.stopPropagation()}>
                      <QuantityModifier
                        className={`pr${data.item_id} ${cartType}`}
                        value={getItem(data.item_id).quantity}
                        onDecrement={handleRemoveClick}
                        onIncrement={handleAddClick}
                        onUpdate={(quantity) => { handleInputUpdateQuantity(data,quantity) }}
                        promoProduct={promoProduct}
                        isLoading={isLoading}
                        variant={variant}
                      />
                    </div>
                  }
                    </ProductButtons>
              : data.is_shop_open
                ? outOfStock
                  ? <div className={promoProduct ? "promo-price" : ""} style={{ width: '100%', color: "red",  textAlign: 'end' }}>{ t('shop_item_out_of_stock') }</div>
                    : <ProductButtons>
                      {!isInCart(data.item_id) ?
                          <>
                            <Button className="btn-outline-express" onClick={!isLoading && handleAddClick} >
                              {isLoading
                                ? <Spinner animation="border" role="status" size="sm" style={{color: "#f01266"}}/>
                                : <span className="cart-icon express"><CartBuy/></span>
                              }
                              <span className="cart-buy">Buy</span>
                            </Button>
                          </>
                        :
                        <div onClick={(e)=>e.stopPropagation()}>
                          <QuantityModifier
                            className={`pr${data.item_id} ${cartType}`}
                            value={getItem(data.item_id).quantity}
                            onDecrement={handleRemoveClick}
                            onIncrement={handleAddClick}
                            onUpdate={(quantity) => { handleInputUpdateQuantity(data,quantity) }}
                            promoProduct={promoProduct}
                            isLoading={isLoading}
                          />
                        </div>
                        // <div onClick={(e) => e.stopPropagation()} className="ml-auto">
                        // <Button variant="danger"
                        //       className={`btn btn-outline-success ${itemQ >= 1 ? 'in-cart express' : ''}`}
                        //       onClick={onClick}
                        // >
                        //   <div className="item-qty">+{itemQ}</div>
                        // </Button>
                        // </div>
                      }
                    </ProductButtons>
                    : outOfStock
                  ? <div className={promoProduct ? "promo-price" : ""} style={{ color: "red" }}>{ t('shop_item_out_of_stock') }</div>
                  : null
                }
                </div>

            {/* <div className="product-country-and-btn">
              {
                data.countries[0] ? <span className="country-label"><FlagIcon code={data.countries[0].code.toLowerCase()} /></span> : null
              }
              {cartType !== "express"
              ? outOfStock
                ? <div className={promoProduct ? "promo-price" : ""} style={{ color: "red" }}>{ t('shop_item_out_of_stock') }</div>
                : !isInCart(data.item_id)
                  ? <Button colors="success"
                            className={promoPrice ? "btn btn-outline-success promo-cart-button "+"cart-button pr"+data.item_id : "btn btn-outline-success cart-button pr"+data.item_id}
                            onClick={handleAddClick}
                  >
                    {isLoading
                      ? <Spinner animation="border" role="status" size="sm">
                        <span className="sr-only">{ t('toast_downloading') }</span>
                      </Spinner>
                      :<>
                        <span style={{ position: 'relative', top: -2, marginRight: 5 }}><CartIcon /></span> { t('button_add_to_cart') }
                      </>
                    }
                  </Button>
                  : <div onClick={(e)=>e.stopPropagation()}>
                    <QuantityModifier
                      className={`pr${data.item_id} ${cartType}`}
                      value={getItem(data.item_id).quantity}
                      onDecrement={handleRemoveClick}
                      onIncrement={handleAddClick}
                      onUpdate={(quantity) => { handleInputUpdateQuantity(data,quantity) }}
                      promoProduct={promoProduct}
                      isLoading={isLoading}
                    />
                  </div>
              : data.is_shop_open
                ? outOfStock
                  ? <div className={promoProduct ? "promo-price" : ""} style={{ color: "red" }}>{ t('shop_item_out_of_stock') }</div>
                  : !isInCart(data.item_id)
                    ? <Button colors="success"
                              className={promoProduct ? "btn btn-outline-success promo-cart-button "+"cart-button pr"+data.item_id : "btn btn-outline-success cart-button pr"+data.item_id}
                              onClick={handleAddClick}
                    >
                      {isLoading
                        ? <Spinner animation="border" role="status" size="sm">
                          <span className="sr-only">{ t('toast_downloading') }</span>
                        </Spinner>
                        :<>
                          <span style={{ position: 'relative', top: -2, marginRight: 5 }}><CartIcon /></span> { t('button_add_to_cart') }
                        </>
                      }
                    </Button>
                    : <div onClick={(e)=>e.stopPropagation()}>
                      <QuantityModifier
                        className={`pr${data.item_id} ${cartType}`}
                        value={getItem(data.item_id).quantity}
                        onDecrement={handleRemoveClick}
                        onIncrement={handleAddClick}
                        onUpdate={(quantity) => { handleInputUpdateQuantity(data,quantity) }}
                        promoProduct={promoProduct}
                        isLoading={isLoading}
                      />
                    </div>
                : outOfStock
                  ? <div className={promoProduct ? "promo-price" : ""} style={{ color: "red" }}>{ t('shop_item_out_of_stock') }</div>
                  : null
            }
            </div> */}

          </div>
        </ProductInfo>}
      </ProductCardWrapper>

      <SimpleMessageDialog show={showError}
                           message={errorMessage}
                           showHeader={showHeaderDialog}
                           closeLabel={closeLabel}
                           confirmLabel={confirmLabel}
                           headerLabel={dialogHeaderLabel}
                           isConfirmButton={isConfirmButton}
                           onClose={closeSimpleDialog}
                           onConfirm={onConfirm}
                           backdrop={simpleDialogBackdrop}
                           loading={dialogLoading}
                           cartType={cartType}
      />
    </>
  );
};

export default ProductCard;
